import React, { useEffect, useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import styles from './Hero.module.css';

const Hero = () => {
  // Rotating word state
  const [wordIndex, setWordIndex] = useState(0);
  const words = useMemo(() => [
    'Teaching',
    'Inspiring',
    'Learning',
    'Creating',
    'Performing'
  ], []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setWordIndex((prev) => (prev === words.length - 1 ? 0 : prev + 1));
    }, 2000);
    return () => clearTimeout(timer);
  }, [wordIndex, words.length]);

  return (
    <header id="home" className={styles.hero}>
      <div className={styles.gradientBg}>
      </div>
      <div className={styles.content}>
        <h1>
          Spend More Time{' '}
          <span className={styles.rotatingContainer}>
            {words.map((word, index) => (
              <motion.span
                key={index}
                className={styles.rotatingWord}
                initial={{ opacity: 0, y: '-100%' }}
                animate={
                  wordIndex === index
                    ? { opacity: 1, y: '0%' }
                    : wordIndex > index
                    ? { opacity: 0, y: '-150%' }
                    : { opacity: 0, y: '150%' }
                }
                transition={{ type: 'spring', stiffness: 50 }}
              >
                {word}
              </motion.span>
            ))}
          </span>

        </h1>
        <h1>Less Time Managing.</h1>
        <p>
          Get a professional AI-generated website and smart scheduling assistant that works 24/7. Focus on teaching music while AI handles your online presence and bookings.
        </p>
      </div>
    </header>
  );
};

export default Hero;